module.exports = __webpack_public_path__ + "resources/img/img_sectigo_ssl1_m.f2193df5f2df8ee11f324b1401a13d16.png";